import { Suspense } from "react";
import KanbanBoardSkeleton from "../../components/Skeleton/KanbanBoardSkeleton";
import KanbanWrapperBoard from "../../components/OptimizedKanban/KanbanBoardWrapper";

// const KanbanBoard = lazy(() => import("../../components/Kanban/kanbanBoard"));

// const OptimizedKanbanBoard = lazy(
//   () => import("../../components/OptimizedKanban/OptimizedKanbanBoard")
// );
export function CRM() {
  return (
    <Suspense fallback={<KanbanBoardSkeleton />}>
      {/* <KanbanBoard /> */}
      {/* <OptimizedKanbanBoard /> */}
      <KanbanWrapperBoard />
    </Suspense>
  );
}
